import GenericVideoDialog from "./GeneralVideoDialog";
import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {StudentDeclinedDialogId} from "./VideoChat";

@inject('videoChatStore')
@observer
export class StudentDeclinedDialog extends Component {
    render() {
        const {isOpen, closeDialog, handleOnClose, handleCancel, handleAccept, videoChatStore} = this.props;
        return <GenericVideoDialog dialogId={StudentDeclinedDialogId} isOpen={isOpen}
                                   onClose={closeDialog}
                                   titleKey={'video.chat.teacher.student.declined.title'}
                                   textKey={'video.chat.teacher.student.declined.text'}
                                   itemName={videoChatStore.lastDeclinedUser?.name}
                                   buttonKey={'teacher.dismiss'}
                                   handleClose={handleOnClose}
                                   handleAccept={handleAccept}
        />
    }
}